type Role = 'SUPER_ADMIN' | 'DISPATCH'

type SidebarObj = {
  label: string
  href: string
  allowedRoles?: Role[]
  /** If true, item is hidden until the user has at least one factoring-enabled company association. */
  requiresFactoringCompany?: boolean
}

export const mainSidebars: SidebarObj[] = [
  { label: 'Home', href: 'home' },
  // Order page is visible to all roles, but specific sections
  // are restricted inside the page for dispatch users.
  { label: 'Order', href: 'order' },
  { label: 'Driver Trip', href: 'trip' },
  { label: 'Carrier Trip', href: 'carrier-trip' },
]

/** Nested under the expandable Receivables section (same pattern as Payables). */
export const receivablesSidebars: SidebarObj[] = [
  // Direct = former Invoice; hidden for dispatch users
  { label: 'Direct', href: 'invoice', allowedRoles: ['SUPER_ADMIN'] },
  {
    label: 'Factored',
    href: 'factoring',
    allowedRoles: ['SUPER_ADMIN'],
    requiresFactoringCompany: true,
  },
]

/** Nested under the expandable Payables section (same pattern as More). */
export const payablesSidebars: SidebarObj[] = [
  { label: 'Carrier', href: 'carrier', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Vendor', href: 'vendor', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Driver', href: 'driver-payables', allowedRoles: ['SUPER_ADMIN'] },
]

export const moreSidebars: SidebarObj[] = [
  { label: 'Address', href: 'address', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Equipment', href: 'equipment' },
  // The following modules are restricted to super admins
  { label: 'Driver', href: 'driver', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Integration', href: 'integration', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Commission', href: 'commission', allowedRoles: ['SUPER_ADMIN'] },
  { label: 'Settings', href: 'settings', allowedRoles: ['SUPER_ADMIN'] },
]

// Keep for backward compatibility if needed elsewhere
export const sidebars: SidebarObj[] = [
  ...mainSidebars,
  ...receivablesSidebars,
  ...payablesSidebars,
  ...moreSidebars,
]
